<template>
	<div>
		<v-list dense>
			<v-list-item>
				<v-list-item-icon>
					<v-icon color="accent">mdi-clipboard-flow</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Gesamtdelegation</v-list-item-title>
					<v-list-item-subtitle class="wrap">
						<ul>
							<li>Die Gesamtdelegation ermöglicht es Ihnen, Erhebungsteile nach unserem vordefinierten Schema an an Andere zu delegieren und somit mühelos die sachgerechte Bearbeitung der Reigfegraderhebung zu gewähleisten.</li>
						</ul>
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
			<v-list-item>
				<v-list-item-icon>
					<v-icon color="green">mdi-account</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Teildelegation</v-list-item-title>
					<v-list-item-subtitle class="wrap">
						<ul>
							<li>Über die Funktion ‚Teildelegation‘ beteiligen Sie weitere Personen an der Bearbeitung der Erhebung, indem Sie ihnen einzelne Abschnitte zur Bearbeitung weiterleiten.</li>
						</ul>
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
			<v-list-item>
				<v-list-item-icon>
					<v-icon color="primary">mdi-account-multiple-check</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Quick Poll</v-list-item-title>
					<v-list-item-subtitle class="wrap">
						<ul>
							<li>
								Mit der Quick-Poll-Funktion haben Sie die Möglichkeit, einer Gruppe von Personen die Inhalte eines Befragungsabschnitts zur Beantwortung vorzulegen, um daraufhin die so eingeholten Antworten zum Zwecke Ihrer eigenen Entscheidungsfindung bei dem Beantworten dieses Abschnitts hinzuzuziehen.

							</li>
						</ul>
					</v-list-item-subtitle>
				</v-list-item-content>


			</v-list-item>
			<!-- <v-list-item>
				<v-list-item-icon>
					<v-icon color="green">mdi-account-group</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Mitarbeiterumfrage</v-list-item-title>
					<v-list-item-subtitle class="wrap">
						<ul>
							<li>Mit dieser Funktion ist es Ihnen möglich, Teile der Erhebung mittels einer Umfrage unter der weiteren Belegschaft Ihres Hauses zu verteilen, um bei Bedarf die Sichtweisen aller Mitarbeiter bei der Antwortfindung mit einzubeziehen.</li>
						</ul>
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item> -->
		</v-list>



	</div>
</template>

<script>
	export default {
		name: "CollaborationTypes"
	}
</script>
